import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const channels = [
  {
    icon: 'ri-telegram-fill',
    name: 'Telegram',
    desc: 'Массовая рассылка личных сообщений через Telegram-аккаунты. Антиспам-ротация, авто-прогрев аккаунтов, защита от блокировок.',
    features: ['Авто-прогрев номеров', 'Антиспам-ротация', 'Персонализация сообщений', 'Автоответчик на входящие'],
  },
  {
    icon: 'ri-whatsapp-fill',
    name: 'WhatsApp',
    desc: 'Рассылка через WhatsApp Business API и обычные аккаунты. Высокая доставляемость, карусели, кнопки быстрых ответов.',
    features: ['WA Business API', 'Кнопки и карусели', 'Шаблоны сообщений', 'Массовая отправка'],
  },
  {
    icon: 'ri-smartphone-fill',
    name: 'Max',
    desc: 'Рассылка в мессенджере Max. Охват аудитории, которая не сидит в Telegram и WhatsApp. Дополнительный канал для максимальной конверсии.',
    features: ['Ручная модерация', 'Таргетинг по интересам', 'Рассылка по группам', 'Высокий % прочтения'],
  },
];

export default function MMChannels() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Каналы
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Три канала
            <br />
            для максимального охвата
          </h2>
          <p ref={descRef} className={`mt-3 text-[14.5px] text-foreground-500 max-w-lg mx-auto reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
            Отправляем сообщения с наших номеров. Никаких проблем с блокировками ваших аккаунтов.
          </p>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {channels.map((ch, i) => (
            <div
              key={ch.name}
              className={`bg-background-50 rounded-xl border border-background-200 p-6 md:p-7 flex flex-col reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''}`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 150}ms` } : undefined}
            >
              <span className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600 mb-4">
                <i className={`${ch.icon} text-lg`}></i>
              </span>
              <h3 className="font-display font-bold text-[18px] text-foreground-950">{ch.name}</h3>
              <p className="mt-3 text-[14px] text-foreground-500 leading-relaxed">{ch.desc}</p>
              <ul className="mt-5 flex flex-col gap-2">
                {ch.features.map((f) => (
                  <li key={f} className="flex items-center gap-2.5 text-[13px] text-foreground-700">
                    <span className="text-primary-500"><i className="ri-check-line text-sm"></i></span>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}